<template>
    <path d="M14.0007 25.6666C7.55715 25.6666 2.33398 20.4435 2.33398 14C2.33398 7.55648 7.55715 2.33331 14.0007 2.33331C20.4442 2.33331 25.6673 7.55648 25.6673 14C25.6673 20.4435 20.4442 25.6666 14.0007 25.6666ZM14.0007 23.3333C16.476 23.3333 18.85 22.35 20.6003 20.5996C22.3507 18.8493 23.334 16.4753 23.334 14C23.334 11.5246 22.3507 9.15066 20.6003 7.40032C18.85 5.64998 16.476 4.66665 14.0007 4.66665C11.5253 4.66665 9.15133 5.64998 7.40099 7.40032C5.65065 9.15066 4.66732 11.5246 4.66732 14C4.66732 16.4753 5.65065 18.8493 7.40099 20.5996C9.15133 22.35 11.5253 23.3333 14.0007 23.3333ZM12.834 17.5H15.1673V19.8333H12.834V17.5ZM12.834 8.16665H15.1673V15.1666H12.834V8.16665Z" fill="white"/>
</template>

<script>
    export default {
        name: 'icon-error'
    }
</script>